import { globalTheme } from "srs.sharedcomponents/lib/esm/styles/config";

const robinairThemeColor = "#E83A42";
export const customTheme = {
  ...globalTheme,
  colors: {
    ...globalTheme.colors,
    primary: robinairThemeColor,
  },
};
